<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="wrapper">
    <img :src="img"
         v-bind:style="styleObj"
         v-tap="{methods:close}"
         alt=""/>
    <i class="left" v-tap="{methods:handlePre}"></i>
    <i class="right" v-tap="{methods:handleNext}"></i>
  </div>
</template>

<script>
  export default{
    name: 'picture-view',
    created() {
      this.imageObj = new Image();
      let _that = this;
      this.imageObj.onload = function () {
        _that.w = this.width;
        _that.h = this.height;
      };
      this.imageObj.src = this.img;
    },
    updated() {},
    deactivated() {
      this.$destroy();
    },
    methods: {
      handlePre() {
        if (this.mIndex === 0) {
          console.log('this is first img');
          return;
        }
        this.mIndex--;
        this.imageObj.src = this.img;
      },
      handleNext() {
        if (this.mIndex === this.imgs.length - 1) {
          console.log('this is last img');
          return;
        }
        this.mIndex++;
        this.imageObj.src = this.img;
      },
      close() {
        this.$store.commit('clearImgInfo');
        this.$router.goBack();
      }
    },
    data() {
      return {
        mIndex: this.$store.state.pictureView.index,
        imageObj: {},
        w: 0,
        h: 0,
        imgs: this.$store.state.pictureView.imgs
      };
    },
    computed: {
      img() {
        if (this.imgs[this.mIndex]) {
          return this.imgs[this.mIndex];
        } else {
          return '';
        }
      },
      width () {
        let winWidth = window.innerWidth;
        let winHeight = window.innerHeight;
        let realW = winHeight / this.h * this.w;
        if (this.h / this.w > 1.2) {
          // 竖图
          return realW;
        } else {
          // 横图
          return winWidth;
        }
      },
      height () {
        let winWidth = window.innerWidth;
        let winHeight = window.innerHeight;
        let realH = winWidth / this.w * this.h;
        if (this.h / this.w > 1.2) {
          // 竖图
          return winHeight;
        } else {
          // 横图
          return realH;
        }
      },
      paddingLeft () {
        let winWidth = window.innerWidth;
        let winHeight = window.innerHeight;
        let realW = winHeight / this.h * this.w;
        let paddingLeft = parseInt((winWidth - realW) / 2);
        if (this.h / this.w > 1.2) {
          // 竖图
          return paddingLeft;
        } else {
          // 横图
          return 0;
        }
      },
      paddingTop () {
        let winWidth = window.innerWidth;
        let winHeight = window.innerHeight;
        let realH = winWidth / this.w * this.h;
        let paddingTop = parseInt((winHeight - realH) / 2);
        if (this.h / this.w > 1.2) {
          // 竖图
          return 0;
        } else {
          // 横图
          return paddingTop;
        }
      },
      styleObj() {
        return {
          height: this.height + 'px',
          width: this.width + 'px',
          paddingLeft: this.paddingLeft + 'px',
          paddingTop: this.paddingTop + 'px'
        };
      }
    },
    watch:{
      "img":{
        handler(newVal,oldVal){
          console.log(newVal,"///");
        }
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .wrapper {
    background-color: black;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    z-index: 5;
    img {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 6;
    }
    .left {
      background: url('../assets/img/common/left.png') no-repeat 0 0;
      position: fixed;
      top: 44%;
      display: block;
      height: px2rem(64);
      width: px2rem(64);
      z-index: 7;
    }
    .right {
      background: url('../assets/img/common/right.png') no-repeat 0 0;
      position: fixed;
      top: 44%;
      right: 0;
      display: block;
      height: px2rem(64);
      width: px2rem(64);
      z-index: 7;
    }
  }
</style>



// WEBPACK FOOTER //
// PictureView.vue?b880af0a